export default {
  item: {},
  items: [],
  pagination: {},
  tree: [],
  menuCategory: [],
  clean: false,
  allCategories: [],
  isClean: false
}
